import * as Types from '../graphQlTypes.generated';

import { graphQlService } from '@doxyme/frontend/services/graphql.service';
export type CreateBillingPortalSessionMutationVariables = Types.Exact<{
  input: Types.CreateBillingPortalSessionInput;
}>;


export type CreateBillingPortalSessionMutation = { __typename?: 'Mutation', createBillingPortalSession: { __typename?: 'BillingPortalSession', url: string } };

export type GetPlansQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetPlansQuery = { __typename?: 'Query', Entitlements: { __typename?: 'EntitlementsQueries', getPlans: { __typename?: 'PlansDto', currency: string, plans: Array<{ __typename?: 'PlanDto', id: string, name: string, isCurrentPlan: boolean, seats: Array<{ __typename?: 'PlanSeatDto', type: string, prices: Array<{ __typename?: 'PriceDto', id: string, unit_amount: number, currency: string, interval?: string | null, isCurrentPrice: boolean }> }> }> } } };

export type CreateStripeCheckoutSessionMutationVariables = Types.Exact<{
  input: Types.CreateCheckoutSessionInput;
}>;


export type CreateStripeCheckoutSessionMutation = { __typename?: 'Mutation', createStripeCheckoutSession: { __typename?: 'CheckoutSession', url: string } };

export type CreateOnboardingStripeCheckoutSessionMutationVariables = Types.Exact<{
  input: Types.CreateOnboardingCheckoutSessionInput;
}>;


export type CreateOnboardingStripeCheckoutSessionMutation = { __typename?: 'Mutation', createOnboardingStripeCheckoutSession: { __typename?: 'CheckoutSession', url: string } };

export type GetBillingDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetBillingDataQuery = { __typename?: 'Query', Entitlements: { __typename?: 'EntitlementsQueries', getBillingData: { __typename?: 'BillingDataDto', customerId?: string | null, billingInterval?: string | null, trialEndDay?: number | null, trialStartDay?: number | null, isOnTrial?: boolean | null, currentPeriodEndDay?: number | null, subscriptionStatus?: string | null } } };

export type CreateStripeProTrialMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type CreateStripeProTrialMutation = { __typename?: 'Mutation', createStripeProTrial: boolean };

export type GetUpgradePreviewQueryVariables = Types.Exact<{
  input: Types.UpgradePreviewInput;
}>;


export type GetUpgradePreviewQuery = { __typename?: 'Query', Entitlements: { __typename?: 'EntitlementsQueries', getUpgradePreview: { __typename?: 'UpgradePreviewDto', amountDueToday: number, ongoingCost: number, interval: string, currency: string } } };

export type ConfirmUpgradeMutationVariables = Types.Exact<{
  input: Types.ConfirmUpgradeInput;
}>;


export type ConfirmUpgradeMutation = { __typename?: 'Mutation', confirmUpgrade: { __typename?: 'ConfirmUpgradeDto', success: boolean, subscriptionId: string, invoiceId?: string | null, amountCharged?: number | null } };


export const CreateBillingPortalSessionDocument = `
    mutation createBillingPortalSession($input: CreateBillingPortalSessionInput!) {
  createBillingPortalSession(input: $input) {
    url
  }
}
    `;
export const GetPlansDocument = `
    query getPlans {
  Entitlements {
    getPlans {
      plans {
        id
        name
        isCurrentPlan
        seats {
          type
          prices {
            id
            unit_amount
            currency
            interval
            isCurrentPrice
          }
        }
      }
      currency
    }
  }
}
    `;
export const CreateStripeCheckoutSessionDocument = `
    mutation CreateStripeCheckoutSession($input: CreateCheckoutSessionInput!) {
  createStripeCheckoutSession(input: $input) {
    url
  }
}
    `;
export const CreateOnboardingStripeCheckoutSessionDocument = `
    mutation CreateOnboardingStripeCheckoutSession($input: CreateOnboardingCheckoutSessionInput!) {
  createOnboardingStripeCheckoutSession(input: $input) {
    url
  }
}
    `;
export const GetBillingDataDocument = `
    query GetBillingData {
  Entitlements {
    getBillingData {
      customerId
      billingInterval
      trialEndDay
      trialStartDay
      isOnTrial
      currentPeriodEndDay
      subscriptionStatus
    }
  }
}
    `;
export const CreateStripeProTrialDocument = `
    mutation CreateStripeProTrial {
  createStripeProTrial
}
    `;
export const GetUpgradePreviewDocument = `
    query GetUpgradePreview($input: UpgradePreviewInput!) {
  Entitlements {
    getUpgradePreview(input: $input) {
      amountDueToday
      ongoingCost
      interval
      currency
    }
  }
}
    `;
export const ConfirmUpgradeDocument = `
    mutation ConfirmUpgrade($input: ConfirmUpgradeInput!) {
  confirmUpgrade(input: $input) {
    success
    subscriptionId
    invoiceId
    amountCharged
  }
}
    `;

const injectedRtkApi = graphQlService.injectEndpoints({
  endpoints: (build) => ({
    createBillingPortalSession: build.mutation<CreateBillingPortalSessionMutation, CreateBillingPortalSessionMutationVariables>({
      query: (variables) => ({ document: CreateBillingPortalSessionDocument, variables })
    }),
    getPlans: build.query<GetPlansQuery, GetPlansQueryVariables | void>({
      query: (variables) => ({ document: GetPlansDocument, variables })
    }),
    CreateStripeCheckoutSession: build.mutation<CreateStripeCheckoutSessionMutation, CreateStripeCheckoutSessionMutationVariables>({
      query: (variables) => ({ document: CreateStripeCheckoutSessionDocument, variables })
    }),
    CreateOnboardingStripeCheckoutSession: build.mutation<CreateOnboardingStripeCheckoutSessionMutation, CreateOnboardingStripeCheckoutSessionMutationVariables>({
      query: (variables) => ({ document: CreateOnboardingStripeCheckoutSessionDocument, variables })
    }),
    GetBillingData: build.query<GetBillingDataQuery, GetBillingDataQueryVariables | void>({
      query: (variables) => ({ document: GetBillingDataDocument, variables })
    }),
    CreateStripeProTrial: build.mutation<CreateStripeProTrialMutation, CreateStripeProTrialMutationVariables | void>({
      query: (variables) => ({ document: CreateStripeProTrialDocument, variables })
    }),
    GetUpgradePreview: build.query<GetUpgradePreviewQuery, GetUpgradePreviewQueryVariables>({
      query: (variables) => ({ document: GetUpgradePreviewDocument, variables })
    }),
    ConfirmUpgrade: build.mutation<ConfirmUpgradeMutation, ConfirmUpgradeMutationVariables>({
      query: (variables) => ({ document: ConfirmUpgradeDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useCreateBillingPortalSessionMutation, useGetPlansQuery, useLazyGetPlansQuery, useCreateStripeCheckoutSessionMutation, useCreateOnboardingStripeCheckoutSessionMutation, useGetBillingDataQuery, useLazyGetBillingDataQuery, useCreateStripeProTrialMutation, useGetUpgradePreviewQuery, useLazyGetUpgradePreviewQuery, useConfirmUpgradeMutation } = injectedRtkApi;

